import axios from "axios";
import { transformResponsePreservingIds } from "../common/jsonPreservingIds";
import SnackbarUtils from "../components/NotistackPlus";
import { RIMS_COOKIE_CONSTANTS } from "../constants";
import { useConfigStore } from "../store/config";
import { t } from "i18next";
import cookie from "react-cookies";
// import { toast } from 'react-toastify';

declare module "axios" {
  interface AxiosRequestConfig {
    /** Skip the global error toast; the caller shows its own message. */
    silent?: boolean;
  }
}

// const isPrd = process.env.NODE_ENV === 'production';

//export const basicUrl = isPrd ? 'https://88xqd6km6b.execute-api.us-east-1.amazonaws.com' : 'http://localhost:3000/api'

export const basicUrl = process.env.REACT_APP_API_GETWAY;
const refreshURL = "/common-auth/refresh";

declare module "axios" {
  export interface AxiosRequestConfig {
    /** Caller shows its own error UI (for example Data Lock 3015). */
    skipGlobalErrorToast?: boolean;
  }
}

axios.defaults.transformResponse = [transformResponsePreservingIds];

const service = axios.create({
  baseURL: basicUrl,
  transformResponse: [transformResponsePreservingIds],
});

service.interceptors.request.use(
  (config) => {
    const language = useConfigStore.getState()?.language;
    const languageformat = language === "en" ? "" : language;
    let token = cookie.load(RIMS_COOKIE_CONSTANTS.LOGIN_TOKEN);
    // config.withCredentials = true;
    token
      ? (config.headers = {
          "Content-Type":
            config.responseType === "arraybuffer" &&
            JSON.stringify(config.data) === "{}"
              ? "application/octet-stream;charset=utf-8"
              : "application/json;charset=utf-8",
          Authorization: `Bearer ${token}`,
          "Accept-Language": languageformat || "",
        })
      : (config.headers = {
          "Content-Type": "application/json;charset=utf-8",
        });
    // config.data = QS.stringify(config.data)
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

service.interceptors.response.use(
  (response: any) => {
    if (response.config.responseType !== "arraybuffer") {
      if (response.status) {
        switch (response.status) {
          case 200:
            return response.data;
          case 400:
          case 401:
          case 403:
            if (response.config?.url?.indexOf(refreshURL) > -1) {
              // logoutFunction();
              // window.location.href = window.location.origin;
              console.log(
                "I catch err refreshURL 401/400/403 in request. will return",
              );
            }
            return;
          default:
            console.log("error", response.data.msg);
        }
      }
    } else {
      return response;
    }
  },
  (err) => {
    if (err.config?.url?.indexOf(refreshURL) > -1) {
      // logoutFunction();
      // window.location.href = window.location.origin;
      return;
    } else if (err.config?.silent) {
      return Promise.reject(err);
    } else {
      switch (err.response.status) {
        case 401:
          console.log("I catch err 401. will return");
          break;
        case 403:
          break;
        case 400:
        case 500:
          if (!err.config?.skipGlobalErrorToast) {
            SnackbarUtils.error(
              err.response?.data?.message || t("common.tip.commonErrorMessage"),
            );
          }
          break;
        default:
        // SnackbarUtils.error('There is something wrong with server, please try again later')
      }
    }
    return Promise.reject(err);
  },
);

export default service;

// chat
export const chatBasicUrl = process.env.REACT_APP_API_GETWAY_CHAT;
export const chatService = axios.create({
  baseURL: chatBasicUrl, //"https://3a1dgo3yol.execute-api.us-east-1.amazonaws.com/",
  transformResponse: [transformResponsePreservingIds],
});

chatService.interceptors.request.use((config) => {
  let token = cookie.load(RIMS_COOKIE_CONSTANTS.LOGIN_TOKEN);
  token
    ? (config.headers = {
        "Content-Type":
          config.responseType === "arraybuffer" &&
          JSON.stringify(config.data) === "{}"
            ? "application/octet-stream;charset=utf-8"
            : "application/json;charset=utf-8",
        Authorization: `Bearer ${token}`,
      })
    : (config.headers = {
        "Content-Type": "application/json;charset=utf-8",
      });
  return config;
});
chatService.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (err) => {
    SnackbarUtils.error(
      "There is something wrong with server, please try again later",
    );
    return Promise.reject(err);
  },
);
